import styled, { css } from 'styled-components';

export const CardContainer = styled.button`
  border: none;

  margin: 1rem 2rem 0 0;

  display: flex;
  flex-direction: column;
  align-items: center;

  width: 15rem;
  color: #131e23;
  font-family: 'Montserrat', sans-serif;

  background: #f9ede4;

  border-radius: 16px;
  box-shadow: 0 3px 6px rgb(0 0 0/16%);

  transition: 0.5s all;

  ${(props) =>
    props.isSelected &&
    css`
      transform: scale(1.1);
      box-shadow: 0px 0px 45px 0px lightgrey;
    `}

  &:hover {
    transform: ${(props) => (props.isSelected ? `scale(1.1)` : `scale(1.08)`)};
  }
`;

export const Price = styled.span`
  text-align: center;

  position: relative;

  width: 100%;

  padding: 0.7em 0.4em 0.125em 0.4em;

  color: #131e23;
  font-size: 1.25rem;
  font-weight: bold;

  border-radius: 16px 16px 0 0;

  small {
    position: relative;
    top: 2px;
    right: -4px;

    width: 90%;

    color: #131e23;
    font-size: 1rem;
    font-weight: 600;
    text-align: end;
    // letter-spacing: 1px;

    margin-left: auto;
  }
`;

export const BenefitsContainer = styled.div`
  padding: 10px 20px 10px 10px;

  margin-bottom: 10px;

  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (max-width: 1200px) {
    justify-content: center;
  }

  @media (max-width: 640px) {
    margin: 0px;
    flex-direction: column;
    align-items: center;
  }
`;

export const Benefit = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.375rem;

  > p {
    width: 85%;
    font-family: 'Montserrat';
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--green24);
    margin: 0;
    line-height: 1.375;
    text-align: left;
  }

  svg {
    width: 28px;
    height: 28px;
  }

  @media (max-width: 640px) {
    margin: 5px 0px;
  }
`;

export const CopyLinkButton = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 2rem;
  height: 2rem;

  margin-top: 0.75rem;

  color: #7a7a7a;
  cursor: pointer;

  border-radius: 50%;

  transition: 0.2s all;

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }

  &:hover {
    color: #e84e22;
    background: #f2f2f2;
  }
`;

export const Footer = styled.div`
  width: 100%;

  margin-top: auto;

  background: #fff;

  display: flex;
  flex-direction: column;
  align-items: center;

  border-radius: 0 0 16px 16px;
`;

export const FooterText = styled.p`
  display: inline-flex;
  flex-direction: column;

  font-size: 2rem;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  text-align: center;
  line-height: 1.5rem;
`;

export const FooterSubtext = styled.p`
  margin-top: 1.125rem;

  font-size: 1.125rem;
  font-family: 'Montserrat';
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 2px;

  margin-bottom: 0.25rem;
`;
